export default "__VITE_ASSET__0ec18305__"